export default __webpack_public_path__ + "static/media/anugata3.961e9a7a.png";